export default "__VITE_ASSET__XeP3aJL1__"